export default {"src":"/_next/static/media/BRX.be50a380.svg","height":18,"width":18};